import { Button, CharField, Flex, H1, PasswordField, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Formik, getIn } from "formik"
import { Col, Container, Modal } from "react-bootstrap"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { ScrollLayout } from "../../components/ScrollLayout"
import * as yup from "yup"
import { useAuth } from "../../auth"
import { fetchApi } from "@inmagik/react-crud"
import { API_URL } from "../../constants"
import { transformErrorForForm } from "../../utils/utils"

export default function Profilo() {
  const initialValues = {
    old_password: "",
    password: "",
    confirm_password: "",
  }

  const schema = yup.object().shape({
    old_password: yup.string().required().label("Vecchia password"),
    password: yup.string().required().label("Password"),
    confirm_password: yup
      .string()
      .required()
      .oneOf([yup.ref("password")], "Le password non corrispondono")
      .label("Conferma password"),
  })

  useBreadcrumbs([{ label: "Profilo" }])

  const { user, tokens } = useAuth()
  const [modalStateCambiapassword, modalActionsCambiapassword] = useModalTrigger()

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>Profilo</H1>
          <Button
            size="md"
            className="text-white"
            leadingIcon="key"
            variant="primary"
            title="Cambia password"
            onClick={() => {
              modalActionsCambiapassword.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Container fluid className="mt-6">
            <Col md={6}>
              <CharField label="Nome" value={user?.full_name} disabled className="mb-3" />
              <CharField label="Email" value={user?.email} disabled className="mb-3" />
            </Col>
          </Container>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
        onSubmit={async (values, actions) => {
          await fetchApi(API_URL + "/userbase/change-password/", {
            method: "PUT",
            body: JSON.stringify(values),
            responseType: "raw",
            headers: {
              Authorization: `Bearer ${tokens?.access}`,
              "Content-Type": "application/json",
            },
          })
            .then(() => {
              modalActionsCambiapassword.close()
            })
            .catch((e) => {
              actions.setErrors(transformErrorForForm(e))
            })
        }}
      >
        {({ handleSubmit, values, setFieldValue, errors, submitCount }) => {
          return (
            <Modal
              show={modalStateCambiapassword.isOpen}
              onHide={modalActionsCambiapassword.close}
              centered
              backdrop="static"
            >
              <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Cambia password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Container fluid>
                    <PasswordField
                      label="Vecchia password"
                      className="mb-2"
                      value={values.old_password}
                      onChange={(value) => setFieldValue("old_password", value)}
                      errorMessage={getIn(errors, "old_password")}
                      isValid={submitCount > 0 ? !getIn(errors, "old_password") : undefined}
                      required
                    />
                    <PasswordField
                      label="Nuova password"
                      value={values.password}
                      className="mb-2"
                      onChange={(value) => setFieldValue("password", value)}
                      required
                      errorMessage={getIn(errors, "password")}
                      isValid={submitCount > 0 ? !getIn(errors, "password") : undefined}
                    />
                    <PasswordField
                      label="Conferma password"
                      value={values.confirm_password}
                      onChange={(value) => setFieldValue("confirm_password", value)}
                      errorMessage={getIn(errors, "confirm_password")}
                      isValid={submitCount > 0 ? !getIn(errors, "confirm_password") : undefined}
                      required
                    />
                  </Container>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                  <Button
                    title="Annulla"
                    outline
                    size="md"
                    leadingIcon="close"
                    variant="primary"
                    onClick={() => {
                      modalActionsCambiapassword.close()
                    }}
                  />
                  <Button
                    size="md"
                    type="submit"
                    variant="primary"
                    title="Salva"
                    className="text-white"
                    leadingIcon="check"
                  />
                </Modal.Footer>
              </form>
            </Modal>
          )
        }}
      </Formik>
    </Layout>
  )
}
